import { render, staticRenderFns } from "./BatchRunListDialog.vue?vue&type=template&id=2931ff7c&scoped=true"
import script from "./BatchRunListDialog.vue?vue&type=script&lang=js"
export * from "./BatchRunListDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2931ff7c",
  null
  
)

export default component.exports